import "./OrderCard.css";
const OrderCard = ({ children }) => {
  return <div className="OrderCard">{children}</div>;
};

export default OrderCard;
